<template>
    <v-container>
        <v-row>
            <!--Carrossel-->
            <v-col
                    cols="12"
                    lg="12"
                    md="12"
                    sm="12"
                    xs="12"

            >
                <v-carousel cycle :show-arrows="false" hide-delimiters  height="500" v-if="$vuetify.breakpoint.smAndUp">
                    <v-carousel-item
                            :to="'/contact'"
                            src="../assets/banner/b6.png"
                            reverse-transition="fade-transition"
                            transition="fade-transition"
                    ></v-carousel-item>
                </v-carousel>
                <v-carousel cycle :show-arrows="false" hide-delimiters  height="150px" v-else>
                    <v-carousel-item
                            :to="'/contact'"
                            src="../assets/banner/b6.png"
                            reverse-transition="fade-transition"
                            transition="fade-transition"
                    ></v-carousel-item>
                </v-carousel>
            </v-col>
        </v-row>
        <!--Featured Products-->
        <v-row>
            <v-col
                    cols="12"
            >
                <p class="font-weight-bold mb-6 text-center display-2">Featured Products</p>
                <hr>
            </v-col>
        </v-row>
        <!--vitrine-->
        <v-row>
            <v-col
                    cols="6"
                    lg="3"
                    md="3"
                    sm="6"
                    xs="6"
                    v-for="(product,index) in products"
                    :key="index"

            >
                <v-card
                        class="mx-auto"
                        active-class="false"
                        :hover="true"
                        :to="'/'+product.meta_url"
                >
                    <!--no images-->
                    <v-img
                            v-if="!(product.images) && $vuetify.breakpoint.smAndUp"
                            class="white--text align-end"
                            height="400"
                            max-height="420"
                            min-height="170"
                            :src="cdnUrl+'/products/no-img.jpg'"
                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    >
                        <v-card-title style="word-break: break-word;">{{ product.name }}</v-card-title>
                    </v-img>
                    <v-img
                            v-else-if="!(product.images) && $vuetify.breakpoint.xsOnly"
                            class="white--text align-end"
                            height="210"
                            max-height="420"
                            min-height="170"
                            :src="cdnUrl+'/products/no-img.jpg'"
                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    >
                        <v-card-title style="word-break: break-word;">{{ product.name }}</v-card-title>
                    </v-img>
                    <!--images-->
                    <v-img
                            v-else-if="product.images && product.in_stock && $vuetify.breakpoint.smAndUp"
                            class="white--text align-end"
                            height="400"
                            max-height="420"
                            min-height="170"
                            :src="cdnUrl+'/products/'+product.images[0].src"
                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    >
                        <v-card-title style="word-break: break-word;">{{ product.name }}</v-card-title>
                    </v-img>
                    <v-img
                            v-else-if="product.images && product.in_stock == 0 && $vuetify.breakpoint.smAndUp"
                            class="white--text align-end"
                            height="400"
                            max-height="420"
                            min-height="170"
                            :src="cdnUrl+'/products/'+product.images[0].src"
                            gradient="to bottom, rgba(0,0,0,.5), rgba(0,0,0,.8)"
                    >
                        <v-card-title style="word-break: break-word;">{{ product.name }}</v-card-title>
                    </v-img>
                    <v-img
                            v-else-if="product.images && product.in_stock && $vuetify.breakpoint.xsOnly"
                            class="white--text align-end"
                            height="210"
                            max-height="420"
                            min-height="170"
                            :src="cdnUrl+'/products/'+product.images[0].src"
                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    >
                        <v-card-title style="word-break: break-word;">{{ product.name }}</v-card-title>
                    </v-img>
                    <v-img
                            v-else-if="product.images && product.in_stock == 0 && $vuetify.breakpoint.xsOnly"
                            class="white--text align-end"
                            height="210"
                            max-height="420"
                            min-height="170"
                            :src="cdnUrl+'/products/'+product.images[0].src"
                            gradient="to bottom, rgba(0,0,0,.5), rgba(0,0,0,.8)"
                    >
                        <v-card-title >{{ product.name }}</v-card-title>
                    </v-img>
                    <v-card-text class="text--primary d-none d-lg-flex" style="height: 125px">
                        <div style="overflow:hidden;display: -webkit-box;-webkit-line-clamp: 4;-webkit-box-orient: vertical;" v-html="product.short_description"></div>
                    </v-card-text>
                    <v-card-actions >
                        <v-btn
                                v-if="product.consulta == 0"
                                class="title"
                                color="green"
                                text

                        >
                            <span v-if="product.type == 'simple' ">${{ product.regular_price | number_format_real }}</span>
                            <span v-else-if="product.range_price.min == product.range_price.max">${{ product.range_price.min | number_format_real }}</span>
                            <span v-else>
                                ${{ product.range_price.min | number_format_real }}
                            </span>
                        </v-btn>
                        <v-btn
                                v-else
                                small
                                color="red"
                                style="color: #0d47a1;"
                                text
                                outlined
                        >
                            On request
                        </v-btn>
                        <v-btn
                                v-if="product.in_stock"
                                color="orange"
                                icon
                                class="display-4"
                                x-large
                        >
                            <v-icon>mdi-cart</v-icon>
                        </v-btn>
                        <v-btn
                                v-else-if="$vuetify.breakpoint.xsOnly"
                                color="red"
                                style="color: #0d47a1;"
                                icon
                        >

                            <v-img src="../assets/img/not_avaliable.png" width="40px" ></v-img>
                        </v-btn>
                        <v-btn
                                v-else
                                color="red"
                                style="color: #0d47a1;"
                                text
                                outlined
                        >
                            NOT AVALIABLE
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    export default {
        props: {
            appUrl: { type: String },
            cdnUrl: { type: String },
        },
        metaInfo () {
            return {
                title: 'PPS Healthcare – Improving Your Lifestyle',
                meta: [
                    {description: 'PPS Healthcare – Improving Your Lifestyle'},
                    {keywords: 'PPS Healthcare – Improving Your Lifestyle'}
                ]
            }
        },
        data () {
            return {
                products: [
                    {
                        name: ' ',
                        images:false,
                        range_price:[]
                    },
                    {
                        name: ' ',
                        images:false,
                        range_price:[]
                    },
                    {
                        name: ' ',
                        images:false,
                        range_price:[]
                    },
                    {
                        name: ' ',
                        images:false,
                        range_price:[]
                    },
                ],
            }
        },
        methods:{
            loadPage(){
                this.$http.get(this.appUrl+"/store/home").then(response =>{
                    this.products = response.data.products;
                });
            },
        },
        mounted(){
            this.$emit('showCart');
            this.loadPage();
        },
        filters:{
            number_format_real(valor){
                return String(parseFloat(valor).toFixed(2));
            },
        }
    }
</script>
